import api from './http';

const API_URL = '/api';

/**
 * Service de gestion des statuts et transitions
 */
export async function getAvailableStatuses(ticketId) {
  try {
    const response = await api.get(`${API_URL}/tickets/${ticketId}/available-statuses`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors du chargement des statuts disponibles:', error);
    throw error;
  }
}

export async function getStatusTransitions() {
  try {
    const response = await api.get(`${API_URL}/status-transitions`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors du chargement des transitions:', error);
    throw error;
  }
}

export async function validateStatusTransition(ticketId, statusId, collaborateurId = null, tpsResolution = null) {
  try {
    const payload = { statusId: statusId };
    if (collaborateurId) {
      payload.collaborateurId = collaborateurId;
    }
    if (tpsResolution !== null && tpsResolution !== undefined && tpsResolution !== '') {
      payload.tpsResolution = Number(tpsResolution);
    }
    const response = await api.post(`${API_URL}/tickets/${ticketId}/validate-transition`, payload);
    return response.data;
  } catch (error) {
    if (error.response?.status === 400) {
      return error.response.data;
    }
    console.error('Erreur lors de la validation de la transition:', error);
    throw error;
  }
}

/**
 * Obtient les statuts disponibles pour un ticket avec validation
 */
export async function getValidStatusesForTicket(ticketId) {
  try {
    const [availableStatuses, transitions] = await Promise.all([
      getAvailableStatuses(ticketId),
      getStatusTransitions()
    ]);

    return {
      statuses: availableStatuses,
      transitions: transitions,
      isValid: true
    };
  } catch (error) {
    return {
      statuses: [],
      transitions: {},
      isValid: false,
      error: error.message
    };
  }
}

/**
 * Valide une transition avant de l'appliquer
 */
export async function validateTransitionBeforeApply(ticketId, statusId, collaborateurId = null, tpsResolution = null) {
  try {
    const result = await validateStatusTransition(ticketId, statusId, collaborateurId, tpsResolution);
    
    if (!result.valid) {
      return {
        valid: false,
        errors: result.errors || ['Transition non autorisée']
      };
    }

    return {
      valid: true,
      errors: []
    };
  } catch (error) {
    return {
      valid: false,
      errors: ['Erreur lors de la validation de la transition']
    };
  }
}

export default {
  getAvailableStatuses,
  getStatusTransitions,
  validateStatusTransition,
  getValidStatusesForTicket,
  validateTransitionBeforeApply
};
